/* =============================================================
   613 - מציאת דגמים לפי מידה, מעמוד המוצר.

   לא נשען על פילטרים של Search & Discovery. מושך את
   products.json של הקולקציה פעם אחת ומסנן בצד הלקוח, כך
   שהמנגנון עובד גם כשהגדרות הסינון בחנות מקובצות.

   כל צירוף דגם+צבע מוצג בנפרד, לפי בקשת הלקוח.
   ============================================================= */
(function () {
  'use strict';

  var SIZE_RE = /size|מידה|taille/i;
  var cache = null;      // הקולקציה נטענת פעם אחת לכל צפייה בעמוד
  var pending = null;

  function t(key, vars) {
    var s = (window.nbSizeFinderStrings || {})[key] || '';
    for (var k in (vars || {})) s = s.replace('{{ ' + k + ' }}', vars[k]);
    return s;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('he-IL', {
        style: 'currency', currency: window.Shopify && window.Shopify.currency
          ? window.Shopify.currency.active : 'ILS', maximumFractionDigits: 0
      }).format(cents);
    } catch (e) { return '₪' + cents; }
  }

  function load(handle) {
    if (cache) return Promise.resolve(cache);
    if (pending) return pending;
    pending = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (j) { cache = j.products || []; return cache; });
    return pending;
  }

  // מאתר את אינדקס אופציית המידה במוצר
  function sizeIndex(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (SIZE_RE.test(opts[i].name || '')) return i;
    }
    return -1;
  }

  function colorOf(p, v) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (/color|צבע|couleur/i.test(opts[i].name || '')) {
        return v['option' + (i + 1)];
      }
    }
    return null;
  }

  function matches(products, size, excludeHandle) {
    var out = [];
    products.forEach(function (p) {
      if (p.handle === excludeHandle) return;
      var si = sizeIndex(p);
      if (si < 0) return;
      (p.variants || []).forEach(function (v) {
        if (!v.available) return;
        if (String(v['option' + (si + 1)]).toLowerCase() !== size.toLowerCase()) return;
        out.push({
          title: p.title,
          handle: p.handle,
          color: colorOf(p, v),
          price: v.price,
          variantId: v.id,
          image: (p.images && p.images[0] && p.images[0].src) || null
        });
      });
    });
    return out;
  }

  function render(box, list, size) {
    var ul = box.querySelector('[data-nb-results]');
    var status = box.querySelector('[data-nb-status]');

    if (!list.length) {
      ul.hidden = true;
      ul.innerHTML = '';
      status.textContent = t('none', { size: size });
      status.hidden = false;
      return;
    }

    status.textContent = t('found', { count: list.length, size: size });
    status.hidden = false;

    ul.innerHTML = list.map(function (r) {
      var img = r.image
        ? '<img class="nb-sizefinder__img" src="' + r.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy" width="60" height="60">'
        : '<span class="nb-sizefinder__img nb-sizefinder__img--empty" aria-hidden="true"></span>';
      var colour = r.color ? '<span class="nb-sizefinder__color">' + r.color + '</span>' : '';
      return '<li class="nb-sizefinder__row">' +
        '<a class="nb-sizefinder__link" href="/products/' + r.handle + '?variant=' + r.variantId + '">' +
          img +
          '<span class="nb-sizefinder__meta">' +
            '<span class="nb-sizefinder__name">' + r.title + '</span>' +
            colour +
            '<span class="nb-sizefinder__price">' + money(r.price) + '</span>' +
          '</span>' +
        '</a></li>';
    }).join('');
    ul.hidden = false;
  }

  function init(box) {
    if (box.__nbInit) return;
    box.__nbInit = true;

    var handle = box.dataset.collection;
    var exclude = box.dataset.currentHandle;
    var status = box.querySelector('[data-nb-status]');
    var buttons = [].slice.call(box.querySelectorAll('[data-nb-size]'));

    function pick(btn) {
      var size = btn.dataset.nbSize;
      buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      status.textContent = t('searching');
      status.hidden = false;

      load(handle)
        .then(function (products) { render(box, matches(products, size, exclude), size); })
        .catch(function () {
          box.querySelector('[data-nb-results]').hidden = true;
          status.textContent = t('error');
          status.hidden = false;
        });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { pick(b); });
    });

    // אם הגולש בחר מידה שאזלה בדגם הנוכחי, נקדים ונציע לו אותה
    var form = document.querySelector('.product-form__submit');
    if (form) {
      new MutationObserver(function () {
        if (!form.hasAttribute('disabled')) return;
        var sel = document.querySelector('variant-selects select, .product-form__input select');
        var cur = null;
        if (sel && SIZE_RE.test(sel.name || '')) cur = sel.value;
        if (!cur) {
          var r = document.querySelector('input[type="radio"]:checked');
          var all = [].slice.call(document.querySelectorAll('input[type="radio"]:checked'));
          all.forEach(function (x) { if (SIZE_RE.test(x.name || '')) cur = x.value; });
        }
        if (!cur) return;
        var match = buttons.filter(function (b) { return b.dataset.nbSize === cur; })[0];
        if (match && !match.classList.contains('is-active')) pick(match);
      }).observe(form, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function boot() {
    document.querySelectorAll('[data-nb-sizefinder]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
